import React from 'react';
import { useTranslation } from 'react-i18next';
import ItmonkeysVideo from '../../../assets/videos/itmonkeys-cloud.mp4';
import DatacenterImage from '../../../assets/images/data-center.jpeg';
import CloudImage from '../../../assets/images/openspaceazure.jpg';
import './IntroSectionDevSecOps.css';

const IntroSectionDevSecOps2: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="intro-section-home intro-section-devsecops-2">
      <div className="intro-section">
        <div className="intro-row-1">
          <div className="intro-text-1">
            <h2>{t('devSecOps.introSection.automation.title', 'Automatisez votre sécurité')}</h2>
            <h3>{t('devSecOps.introSection.automation.description', 'Intégrer la sécurité dans vos pipelines DevOps n\'est plus une option mais une nécessité pour protéger vos applications et données tout en maintenant la vélocité de développement.')}</h3>
          </div>
          <div className="intro-image">
            <video
              className="intro-media"
              autoPlay
              loop
              muted
              playsInline
            >
              <source src={ItmonkeysVideo} type="video/mp4" />
              {t('devSecOps.introSection.videoNotSupported', 'Votre navigateur ne supporte pas la balise vidéo.')}
            </video>
          </div>
        </div>

        <div className="intro-row-2">
          <div className="intro-text-2">
            <h2>{t('devSecOps.introSection.security.title', 'Sécurité by design')}</h2>
            <h3>{t('devSecOps.introSection.security.description', 'Avec l\'évolution constante des menaces, adopter une approche DevSecOps vous permet d\'intégrer la sécurité dès la conception, réduisant les vulnérabilités et les risques en production.')}</h3>
          </div>

          <div className="intro-image">
            <img
              className="intro-media"
              src={DatacenterImage}
              alt={t('devSecOps.introSection.imageAlt', 'Security')}
            />
          </div>
        </div>
        <div className="intro-bottom-home">
          <div className="intro-row-1">
            <div className="intro-text-1">
              <h2>{t('devSecOps.introSection.partnership.title', 'Votre partenaire sécurité.')}</h2>
              <h3>{t('devSecOps.introSection.partnership.description', 'IT Monkeys vous accompagne dans l\'implémentation d\'une stratégie DevSecOps robuste, grâce à une expertise reconnue en sécurité applicative et infrastructure.')}</h3>
            </div>
            <div className="intro-image">
              <img
                src={CloudImage}
                loading="lazy"
                className="intro-media"
                alt={t('devSecOps.introSection.imageAlt', 'DevSecOps')}
              />
            </div>
          </div>
        </div>
        <div className="intro-section-formation">
          <div className="centered-title-formation">
          </div>
        </div>
      </div>
    </div>
  );
};

export default IntroSectionDevSecOps2;
